import React, { useCallback, useContext, useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import useSocket from '../../../socket/useSocket';
import { ANALYTICS_EVENTS, CURRENT_PAGE, DISPLAYPLATFORM, LOCAL_STORAGE_KEY, MEDIACATEGORIES, MODULE, OTT_POSTER_TYPE, PLAYER, RAILTYPE, SOCKET_ACTION, SOCKET_EVENTS, VODTYPE } from '../../../constant';
import { getAssetByID, getMoreMoviesLikeThis, getOttSettings, getSeries } from '../../../Api/api';
import { utility } from '../../../utility/utility';
import PiPageTop from './PiPageTop';
import { FocusContext, useFocusable } from '@noriginmedia/norigin-spatial-navigation';
import RailComponent from './RailComponent';
import { PlatformContext } from '../../../contexts/platformContext';
import { useDispatch, useSelector } from 'react-redux';
import { setOttSettings } from '../../../redux/applicationSlice';
import { Box, Tab, Tabs } from '@mui/material';
import TabPanel from './TabPanel';
import AnalyticsManager from '../../../analytics/analyticsManager';

const PiPage = (props) => {

    const { pageState, setCurrentPageUnderMenu } = props;

    const navigate = useNavigate();
    const location = useLocation();

    const asset = pageState?.asset ?? location.state?.asset ?? null;

    const { ottSettings } = useSelector((state) => state.application);
    const [ottAsset, setOttAsset] = useState(pageState?.asset ?? location?.state?.asset ?? null);
    const [image, setImage] = useState(ottAsset?.Posters ? utility.getPosterUrl(ottAsset?.Posters, OTT_POSTER_TYPE.Landscape) : '');
    const [value, setValue] = useState(0);
    const [tabs, setTabs] = useState(["More Like This"]);
    const [tabData, setTabData] = useState({});
    const user = utility.getValue(LOCAL_STORAGE_KEY.user);

    const dispatch = useDispatch();
    const displayPlatform = useContext(PlatformContext);
    const isMobile = displayPlatform === DISPLAYPLATFORM.MOBILE;

    const { ref, focusKey, focusSelf, focused } = useFocusable({
        focusable: true,
        trackChildren: true,
        autoRestoreFocus: true,
        onFocus: () => { onMouseEnter(null) },
        onBlur: () => { onMouseOut(null) },
        onEnterPress: () => {
            onClick();
        }
    });
    const { ref: trailerRef, focusKey: trailerFocusKey, focusSelf: trailerFocusSelf, focused: trailerFocused } = useFocusable({
        focusable: true,
        trackChildren: true,
        autoRestoreFocus: true,
        onFocus: () => { onMouseEnter(null, true) },
        onBlur: () => { onMouseOut(null, true) },
        onEnterPress: () => {
            onTrailerClick(ottAsset);
        }
    });

    useEffect(() => {
        document.getElementById('pi-page-main').scrollIntoView(0, 0);
    }, []);

    useEffect(() => {
        focusSelf();
    }, [focusSelf]);

    useEffect(() => {
        document.addEventListener('keydown', onKeyPress);
        return () => document.removeEventListener('keydown', onKeyPress);
    }, []);

    useEffect(() => {
        if ((pageState?.asset ?? location?.state?.asset ?? null) == null) {
            window.location.reload();
        }
        loadOttAsset();
    }, [asset, pageState, props]);

    useEffect(() => {
        const updateAsset = pageState?.asset || location.state.asset;
        setOttAsset(updateAsset);
        setImage(updateAsset?.Posters ? utility.getPosterUrl(updateAsset?.Posters, OTT_POSTER_TYPE.Landscape) : '');
    }, [asset, pageState, props]);

    useSocket(SOCKET_EVENTS.onSocketData, (socketData) => {

        if (socketData.module != MODULE.PLATFORM) return;

        switch (socketData.action) {
            case SOCKET_ACTION.PLATFORM_THEME_REFRESH:
                loadOttSettings();
                break;
            default:
                break;
        }
    });

    const onKeyPress = useCallback(({ keyCode }) => {

        if (keyCode === PLAYER.VK_BACK_SPACE || keyCode === PLAYER.BACK_LG || keyCode === PLAYER.RETURN) {
            navigate(-1)
        }

    });

    const onRowFocus = useCallback(({ y, top, ...rest }) => {
        document.getElementById('contentDiv').scrollTo({
            top: top - window.innerHeight / 2,
            behavior: "smooth",
        });
    }, [ref]);

    let theme = {
        bgColor: ottSettings?.themeData?.general?.bgColor ?? "black",
        color: ottSettings?.themeData?.general?.color ?? "white",
        primaryColor: {
            bgColor: ottSettings?.themeData?.primary?.bgColor,
            color: ottSettings?.themeData?.primary?.color,
        },
        secondaryColor: {
            bgColor: ottSettings?.themeData?.secondary?.bgColor,
            color: ottSettings?.themeData?.secondary?.color,
        }


    }

    const loadOttAsset = async () => {
        const ottAssetRes = await getAssetByID(ottAsset._id);
        if (ottAssetRes.success) {
            console.log(ottAssetRes);
            setOttAsset(ottAssetRes.data);
            setImage(ottAssetRes.data?.Posters ? utility.getPosterUrl(ottAssetRes.data?.Posters, OTT_POSTER_TYPE.Landscape) : '');
            loadTabData(ottAssetRes.data);
        }
    }

    const loadOttSettings = async () => {
        const ottSettingRes = await getOttSettings();
        console.log(ottSettingRes);
        if (ottSettingRes.success) {
            console.log(ottSettingRes);
            dispatch(setOttSettings({ ...ottSettingRes.data, piPageSetting: ottSettingRes?.piPageSetting }))
        }
    }

    const loadTabData = async (asset) => {
        if (asset.MediaCategory === MEDIACATEGORIES.Series || asset.MediaCategory === MEDIACATEGORIES.Season || asset.MediaCategory === MEDIACATEGORIES.Episode) {
            const getSeriesRes = await getSeries(asset);
            console.log(getSeriesRes);

            if (getSeriesRes.success) {
                const seasonData = {};
                const validSeasons = [];

                getSeriesRes.data.forEach(s => {
                    if (s.Episodes && s.Episodes.length > 0) {
                        const seasonName = s.SeasonNumber;
                        validSeasons.push(seasonName);

                        if (!seasonData[seasonName]) seasonData[seasonName] = [];
                        seasonData[seasonName] = [...seasonData[seasonName], ...s.Episodes];
                    }
                });

                setTabs([...validSeasons, "More Like This"]);
                setTabData(prev => ({
                    ...prev,
                    ...seasonData
                }));
            }
        }

        // More Like This data
        const res = await getMoreMoviesLikeThis(asset?.Genres?.[0] || "");
        if (res.success) {
            setTabData(prev => ({
                ...prev,
                "More Like This": res.data
            }));
        }
    };

    const onMouseEnter = (e, isTrailer = false) => {
        if (e) e?.preventDefault();
        // change border color
        let playButtonDiv = document.getElementsByClassName(isTrailer ? 'trailer-button' : 'play-button')[0];
        if (playButtonDiv) {
            playButtonDiv.style.borderColor = theme.secondaryColor.bgColor;
            playButtonDiv.style.color = theme.secondaryColor.bgColor;
            playButtonDiv.style.backgroundColor = theme.primaryColor.bgColor;
        }
    }

    const onMouseOut = (e, isTrailer = false) => {
        e?.preventDefault();
        // change border color
        let playButtonDiv = document.getElementsByClassName(isTrailer ? 'trailer-button' : 'play-button')[0];
        if (playButtonDiv) {
            playButtonDiv.style.borderColor = theme.primaryColor.bgColor;
            playButtonDiv.style.color = theme.primaryColor.bgColor;
            playButtonDiv.style.backgroundColor = theme.secondaryColor.bgColor;
        }
    }

    const onClick = () => {
        utility.onPlay(ottAsset, navigate);
    }

    const onTrailerClick = (asset) => {
        if (asset.Trailers.length == 1) {
            let trailer = asset.Trailers[0];
            let trailerAsset = {
                VideoPlaybackUrl: trailer?.Videos[0]?.Url ?? "",
                Title: trailer?.Title ?? '',
            }
            utility.onPlay(trailerAsset, navigate);
        } else {
            navigate('/trailers', {
                state: {
                    trailers: asset.Trailers
                }
            });
        }
    }

    let fontWeight = ottSettings?.themeData?.rail?.fontWeight;
    const isTrailerAvailable = (ottAsset.Trailers?.length ?? 0) > 0;

    const onBackClick = () => {
        if (setCurrentPageUnderMenu) {
            setCurrentPageUnderMenu(CURRENT_PAGE.MAIN);
            navigate("/", { replace: true });
        } else {
            navigate(-1);
        }
    }

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    return (
        <div id='pi-page-main' style={{ height: "100vh", width: "100vw", overflowX: "hidden" }} >
            {/* Back Button */}
            <div
                onClick={onBackClick}
                style={{
                    position: "absolute",
                    top: "62px",
                    left: "15px",
                    zIndex: 1000,
                    cursor: "pointer",
                    color: ottSettings?.themeData?.rail?.color ?? "white",
                    height: "30px",
                    width: "30px",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center"
                }}
            >
                <i className="fa fa-chevron-left" />
            </div>
            <div style={{ height: "auto", width: "100%", position: "relative" }}>
                {isMobile && <div style={{ backgroundImage: `url(${image})`, height: "250px", width: "100%", backgroundSize: "cover", position: "relative" }}>
                    <i onClick={() => { onClick() }} className='fa fa-play-circle' style={{ position: "absolute", top: "50%", left: "50%", transform: "translate(-50%, -50%)", fontSize: "50px", color: theme.primaryColor.bgColor, cursor: "pointer" }} />
                </div>}
                <div style={{ position: "relative", top: isMobile ? -45 : 0 }}>
                    <PiPageTop ottSetting={ottSettings} ottAsset={ottAsset} theme={theme} />
                </div>
                <FocusContext.Provider value={focusKey}>
                    <div ref={ref} className='play-button' onMouseEnter={onMouseEnter} onMouseOut={onMouseOut} style={{ border: `1px solid ${theme.primaryColor.bgColor}`, color: theme.primaryColor.bgColor, backgroundColor: theme.secondaryColor.bgColor, position: "absolute", left: 50, top: isMobile ? 350 : 150, width: isTrailerAvailable ? "200px" : "400px", height: "35px", display: "flex", justifyContent: "center", alignItems: "center" }} onClick={() => { onClick() }}><i className='fa fa-play' /> Play</div>
                </FocusContext.Provider>
                {isTrailerAvailable && <FocusContext.Provider value={trailerFocusKey}>
                    <div ref={trailerRef} className='play-button trailer-button' onMouseEnter={(e) => onMouseEnter(e, true)} onMouseOut={(e) => onMouseOut(e, true)} style={{ border: `1px solid ${theme.primaryColor.bgColor}`, color: theme.primaryColor.bgColor, backgroundColor: theme.secondaryColor.bgColor, position: "absolute", left: 270, top: isMobile ? 350 : 150, width: "200px", height: "35px", display: "flex", justifyContent: "center", alignItems: "center" }} onClick={() => { onTrailerClick(asset) }}><i className='fa fa-play' /> Trailer</div>
                </FocusContext.Provider>}
            </div>
            <div id='contentDiv' style={{ position: "absolute", left: 0, right: 0, top: isMobile ? "70%" : "60%", padding: "0 10px" }}>
                <Box sx={{ width: '100%' }}>
                    <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                        <Tabs
                            variant={isMobile ? "fullWidth" : "scrollable"}
                            scrollButtons={isMobile ? false : "auto"}
                            allowScrollButtonsMobile
                            value={value}
                            onChange={handleChange}
                            style={{ color: ottSettings?.themeData?.rail?.color ?? "white" }}
                            indicatorColor="secondary"
                            textColor="secondary"
                            TabIndicatorProps={{ style: { backgroundColor: ottSettings?.themeData?.rail?.color ?? "white" } }}
                            sx={{ border: "none", color: ottSettings?.themeData?.rail?.color ?? "white", "& .MuiTab-root": { border: "none", outline: "none !important" }, "& .MuiTab-root:focus": { outline: "none !important", }, "& .MuiTabs-indicator": { height: "3px", borderRadius: "2px", }, }}
                        >
                            {tabs.length > 0 && tabs.map(tab => (
                                <Tab
                                    style={{ fontWeight: fontWeight < 4 ? "lighter" : fontWeight < 6 ? "normal" : fontWeight < 8 ? "bold" : "bolder", color: ottSettings?.themeData?.rail?.color ?? "white", fontFamily: ottSettings?.themeData?.rail?.fontFamily ?? "Roboto", fontSize: ottSettings?.themeData?.rail?.fontSize + "px" }}
                                    className='blockquote'
                                    key={tab}
                                    label={tab}
                                />
                            ))}
                        </Tabs>
                    </Box>
                </Box>

                {tabs.length > 0 && tabs.map((tab, idx) => (
                    <TabPanel key={tab} value={value} index={idx}>
                        <RailComponent
                            setOttAsset={
                                displayPlatform === DISPLAYPLATFORM.WEB ? () => { } : setOttAsset
                            }
                            ottSetting={ottSettings}
                            rail={{ OttAsset: tabData[tab] || [] }}
                            onFocus={onRowFocus}
                            index={idx}
                            key={tab}
                            rowIndex={`Rail${idx}`}
                            railType={RAILTYPE.Rail}
                        />
                    </TabPanel>
                ))}
            </div>

        </div >

    );
}

export default PiPage;
